/**
 * What the loading screen shows about where the learner is going. Owner 13 Oct: "instead of showing the world cover, we
 * can simply show the unit image alongwith its title while entering the world" (with the progress bar and numbers); the
 * Quikbase picture only for Quikbase - never for a unit (owner: "it shows quikbase for all worlds loading which is wrong").
 * Web trips are full page loads with a new launch, so the destination comes from that launch: Quikbase (unit -1 or a
 * Quikbase world in the address), or the unit the launch names once the course data has it.
 */
export const QUIKBASE_PICTURE = '/media/quikbase-loading.jpg';

const GENERIC = { eyebrow: '', title: '', line: '', image: null };
// Sol owner-r26-review B: "Teleporting Home" with no picture; Quikbase's picture with "Teleporting to Quikbase"
const QUIKBASE = { eyebrow: 'Going to', title: 'Teleporting to Quikbase', line: 'The hub with every world', image: QUIKBASE_PICTURE };
export const HOME = { eyebrow: 'Going to', title: 'Teleporting Home', line: '', image: null };

const normalize = value => String(value ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');

export const gradeName = grade => {
  const n = Number(grade);
  if (!Number.isInteger(n) || n <= 0) return '';
  const tens = n % 100;
  const suffix = tens >= 11 && tens <= 13 ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th';
  return `${n}${suffix}`;
};

export function loadingDestination({ quikbase = false, tokenValues = null, courseData = null, trip = null } = {}) {
  // leaving this page: the destination of the trip, never the place being left (loadingTrip.js)
  if (trip?.to === 'home') return HOME;
  if (trip?.to === 'quikbase') return QUIKBASE;
  if (trip?.to === 'unit' && trip.unitId) {
    const units = Array.isArray(trip.units) ? trip.units : courseData?.units;
    return loadingDestination({ tokenValues: { ...tokenValues, unitId: trip.unitId, unitName: trip.unitName }, courseData: { ...courseData, units } });
  }
  if (quikbase || String(tokenValues?.unitId ?? '') === '-1') return QUIKBASE;
  const units = Array.isArray(courseData?.units) ? courseData.units : [];
  const byId = tokenValues?.unitId ? units.findIndex(unit => normalize(unit?.id) === normalize(tokenValues.unitId)) : -1;
  const index = byId >= 0 || !tokenValues?.unitName
    ? byId
    : units.findIndex(unit => normalize(unit?.title || unit?.qlUnit) === normalize(tokenValues.unitName));
  const unit = index >= 0 ? units[index] : null;
  const title = String(unit?.title || unit?.qlUnit || '').trim();
  // before the course data arrives the launch already names the unit: its name, no picture yet
  if (!unit || !title) {
    const named = String(tokenValues?.unitName || '').trim();
    return named ? { ...GENERIC, title: named } : GENERIC;
  }
  // the course data carries no grade or subject; the launch names the subject
  const where = [gradeName(courseData?.grade ?? tokenValues?.grade), String(courseData?.subject || tokenValues?.subject || '').trim()].filter(Boolean).join(' ');
  const tutor = String(courseData?.tutorName || unit?.tutorName || '').trim();
  return {
    eyebrow: where ? `Entering ${where}` : 'Entering',
    title: `Unit ${index + 1} · ${title}`,
    line: tutor ? `${tutor} is getting ready…` : 'Getting your world ready…',
    image: unit.unitImage || unit.image || null,
  };
}
